const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-effective">Effective Date: November 20, 2024</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <p>At Giant-Tree Foundation ("we," "our," or "us"), operating under the brand name Elderra, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our website, services, and applications (collectively, the "Services"). By using our Services, you consent to the practices described in this Privacy Policy.</p>

            <h2>1. Information We Collect</h2>
            <h3>1.1 Personal Information</h3>
            <p>We collect personal information that you provide directly to us, such as:</p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Billing information</li>
              <li>Details provided during account creation or service booking</li>
            </ul>

            <h3>1.2 Automatically Collected Information</h3>
            <p>When you use our Services, we may collect certain information automatically, including:</p>
            <ul>
              <li>Device information (e.g., IP address, browser type, operating system)</li>
              <li>Usage data (e.g., pages viewed, time spent on the site, click actions)</li>
              <li>Location data (only if explicitly permitted by you)</li>
            </ul>

            <h3>1.3 Third-Party Information</h3>
            <p>We may receive information about you from third parties, such as payment processors or partner organizations, to facilitate service delivery.</p>

            <h2>2. How We Use Your Information</h2>
            <p>We use the information collected for the following purposes:</p>
            <ul>
              <li><strong>Service Delivery:</strong> To provide, manage, and personalize our Services.</li>
              <li><strong>Customer Support:</strong> To respond to your inquiries and resolve issues.</li>
              <li><strong>Improvement and Development:</strong> To analyze usage trends and enhance our platform.</li>
              <li><strong>Marketing:</strong> To send promotional materials, offers, and updates (you may opt out at any time).</li>
              <li><strong>Security:</strong> To detect and prevent fraudulent activities or unauthorized access.</li>
            </ul>

            <h2>3. Sharing Your Information</h2>
            <p>We do not sell your personal information to third parties. However, we may share your information in the following circumstances:</p>
            <ul>
              <li><strong>With Service Providers:</strong> Trusted third parties who assist us in delivering our Services (e.g., payment processors, hosting providers).</li>
              <li><strong>With DigiCoaches:</strong> To facilitate your training or service sessions.</li>
              <li><strong>For Legal Compliance:</strong> To comply with applicable laws, regulations, or legal processes.</li>
              <li><strong>In Business Transactions:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction.</li>
            </ul>

            <h2>4. Data Security</h2>
            <p>We implement robust security measures to protect your personal information, including:</p>
            <ul>
              <li>Encryption of sensitive data during transmission.</li>
              <li>Secure storage of data on servers with restricted access.</li>
              <li>Regular monitoring for potential vulnerabilities and attacks.</li>
            </ul>
            <p><strong>Note:</strong> While we strive to protect your data, no system is completely secure. Use our Services at your own risk.</p>

            <h2>5. Cookies and Tracking Technologies</h2>
            <p>We use cookies and similar tracking technologies to:</p>
            <ul>
              <li>Enhance your browsing experience.</li>
              <li>Understand usage patterns and preferences.</li>
              <li>Provide targeted advertisements (if applicable).</li>
            </ul>
            <p>You can manage cookie preferences through your browser settings. However, disabling cookies may limit the functionality of our Services.</p>

            <h2>6. Your Rights</h2>
            <h3>6.1 Access and Correction</h3>
            <p>You have the right to access, correct, or update your personal information by contacting us at support@elderra.io.</p>

            <h3>6.2 Data Deletion</h3>
            <p>You can request the deletion of your account or personal information. Please note that certain data may be retained for legal or operational purposes.</p>

            <h3>6.3 Opt-Out</h3>
            <p>You can opt out of receiving marketing communications by following the unsubscribe instructions in our emails or contacting us directly.</p>

            <h2>7. Children's Privacy</h2>
            <p>Our Services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If we become aware that a child's information has been collected, we will delete it immediately.</p>

            <h2>8. International Users</h2>
            <p>If you are accessing our Services from outside India, please note that your data will be processed and stored in India, where data protection laws may differ from those in your jurisdiction.</p>

            <h2>9. Changes to This Privacy Policy</h2>
            <p>We may update this Privacy Policy periodically. Any changes will be posted on this page, and the "Effective Date" will be updated. Continued use of our Services constitutes acceptance of the revised policy.</p>

            <h2>10. Contact Us</h2>
            <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
            <p><strong>Email:</strong> hello@elderra.io</p>
            <p><strong>Address:</strong> H-294, PLOT 2, LANE 2, FIRST FLOOR, WESTEND MARG, NEAR SAKET, SAIDULAJAB, NEW DELHI 110030</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;